import { forwardRef } from 'react'
import { cn } from '@util'
import { type MaterialSymbolType, Typography } from '@front/model'

export type MaterialSymbolIconProps = {
  size?: keyof typeof Typography.size | number | (string & {})
  icon: MaterialSymbolType
  color?: string
  filled?: boolean
  className?: string
}

export const MaterialSymbolIcon = forwardRef<HTMLSpanElement, MaterialSymbolIconProps>(
  ({ size, icon, color, filled, className }, ref) => {
    return (
      <span
        aria-hidden
        ref={ref}
        className={cn('material-symbols-rounded', className)}
        style={{
          fontVariationSettings: filled ? "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24" : undefined,
          fontSize: resolveSize(size),
          color,
        }}
      >
        {icon}
      </span>
    )
  }
)

MaterialSymbolIcon.displayName = 'MaterialSymbolIcon'

const resolveSize = (size: MaterialSymbolIconProps['size'] = 'lg'): string | number => {
  if (Object.keys(Typography.size).some((key) => key === size)) {
    return Typography.size[size as keyof typeof Typography.size]
  }
  return size
}
